import { render } from "./collabStatusBanner.vue?vue&type=template&id=0befdb37&scoped=true&ts=true"
import script from "./collabStatusBanner.vue?vue&type=script&lang=ts"
export * from "./collabStatusBanner.vue?vue&type=script&lang=ts"

import "./collabStatusBanner.vue?vue&type=style&index=0&id=0befdb37&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cow-app/cow-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0befdb37"]])

export default __exports__